import { DepositCard } from '@shared/components/common'
import { GraphQLErrorBoundary } from '@shared/components/errors'
import { useDepositQuery } from '@shared/graphql'
import useTranslation from 'next-translate/useTranslation'

import { FxTransactionHeading } from '../../components'

export interface FxDepositDetailProps {
  /**
   * Deposit Transaction ID.
   */
  id: string
}

export const FxDepositDetail: React.FC<FxDepositDetailProps> = ({ id }) => {
  const { t } = useTranslation('payments')
  const { data, loading, error, refetch } = useDepositQuery({
    variables: {
      id,
    },
  })

  return (
    <GraphQLErrorBoundary error={error} retry={refetch}>
      <FxTransactionHeading
        loading={loading}
        title={t`fxTransactionDetail.title.deposit`}
        transaction={data?.deposit}
      />
      <DepositCard deposit={data?.deposit} loading={loading} />
    </GraphQLErrorBoundary>
  )
}
